// extracted by mini-css-extract-plugin
export default {"selection-container":"styles_selection-container__WjoTK"};